import { SellerUpdateProfileForm } from "../../components/seller/SellerUpdateProfileForm";
import { RedirectToHomeForm } from "../../components/seller/RedirectToHomeForm"

import React from "react";
import Grid from '@mui/material/Grid';
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { AuthHelper } from '../../utils/auth_helper';
import { useNavigate } from "react-router-dom";


function RedirectToHome() {


  return (
    <div>
      <AuthHelper />
      <RedirectToHomeForm />

    </div>
  );

}


export { RedirectToHome };
